import { useStore } from '@mirai/data-sources';
import { useLocale } from '@mirai/locale';
import { Icon, Pressable, styles, Text, useDevice, View } from '@mirai/ui';
import PropTypes from 'prop-types';
import React from 'react';

import { L10N } from './Welcome.l10n';
import * as style from './Welcome.module.css';
import { ICON } from '../../../helpers';
import { INPUT_MODE } from '../../Chat.constants';

const Welcome = ({ settings, onInputMode }) => {
  const { isMobile } = useDevice();
  const { translate } = useLocale();
  const { value: { session: { firstName } = {} } = {} } = useStore();
  const { twilio: { active, whatsappNumber } = {} } = settings || {};

  const isWhatsappActive = active && whatsappNumber;
  const titleProps = { brand: true, headline: true, level: 2 };

  const handleWhatsapp = () => {
    window.open(`https://api.whatsapp.com/send?phone=${encodeURIComponent(whatsappNumber)}`, '_blank');
    onInputMode(INPUT_MODE.WHATSAPP);
  };

  return (
    <View wide className={style.container}>
      <View>
        <Text {...titleProps} bold className={style.title}>
          {`✦ ${translate(L10N.LABEL_HI)} ${firstName ? `, ${firstName}` : ''}`}
        </Text>
        <Text {...titleProps} bold className={style.title}>
          {translate(L10N.LABEL_HOW_HELP)}
        </Text>
      </View>

      <View row={!isMobile} className={styles(style.inputsMode, !!isWhatsappActive && style.whatsapp)}>
        <Pressable onPress={() => onInputMode(INPUT_MODE.TEXT)}>
          <Icon value={ICON.MESSAGE} headline level={1} />
          <Text bold>{translate(L10N.LABEL_MODE_TEXT_TITLE)}</Text>
          <Text small>{translate(L10N.LABEL_MODE_TEXT_DESCRIPTION)}</Text>
        </Pressable>

        <Pressable onPress={() => onInputMode(INPUT_MODE.AUDIO)}>
          <Icon value={ICON.PHONE} headline level={1} />
          <Text bold>{translate(L10N.LABEL_MODE_AUDIO_TITLE)}</Text>
          <Text small>{translate(L10N.LABEL_MODE_AUDIO_DESCRIPTION)}</Text>
        </Pressable>

        {isWhatsappActive && (
          <Pressable onPress={handleWhatsapp}>
            <Icon value={ICON.WHATSAPP} headline level={1} />
            <Text bold>{translate(L10N.LABEL_MODE_WHATSAPP_TITLE)}</Text>
            <Text small>{translate(L10N.LABEL_MODE_WHATSAPP_DESCRIPTION)}</Text>
          </Pressable>
        )}
      </View>
    </View>
  );
};

Welcome.displayName = 'Mirai:Core:Chat.Welcome';

Welcome.propTypes = {
  settings: PropTypes.shape({
    twilio: PropTypes.shape({
      active: PropTypes.bool,
      whatsappNumber: PropTypes.string,
    }),
  }),
  onInputMode: PropTypes.func,
};

export { Welcome };
